<template>
  <t-row class="permissions-table-row">
    <t-column class="permissions-table-row-header">
      <div>
        <span v-tooltip="property.defaultLabelTitle" class="row-header-selector header-text inline-block">
          {{ property.defaultLabelTitle }}
        </span>
        <sensitive-data-icon v-if="propertyIsSecurityTagged" class="pl-1"></sensitive-data-icon>
      </div>
    </t-column>
    <t-column v-for="permittee in permissionsTablePermittees" :key="`${property.client_id}_${permittee.client_id}`" size="">
      <row>
        <input
            :id="`edit_property_permission_${property.client_id}_${permittee.client_id}`"
            type="checkbox"
            @input="createDestroyPermission(permittee, property, ObjectModelPermissionCapabilityType.Edit)"
            :checked="!!permissionFor(permittee, property, ObjectModelPermissionCapabilityType.Edit)"
        >
        <label :for="`edit_property_permission_${property.client_id}_${permittee.client_id}`">
          Edit
        </label>
      </row>
    </t-column>
    <t-column :class="`empty_cell`" v-for="index in remainingColumns" :key="`empty_cell_${index}`" size=""><row>&nbsp;</row></t-column>
  </t-row>
</template>

<script lang="ts">
import Vue from 'vue';
import selectedMixin from "../mixins/selectedMixin";
import ObjectModelPermissionMixin from '../mixins/object-model-permission-mixin';
import permissionTablePermitteesMixin from '../mixins/permission-table-permittees-mixin';
import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
import {ObjectModelPermissionType} from "~/enums/objectModelPermissionType";
import remainingColumnMixin from "../mixins/remaining-column-mixin";
import {StringHelper} from "~/helpers/stringHelper";
import dataTaggableFieldMixin from "../mixins/dataTaggableFieldMixin";
import {IObjectModelProperty} from "~/interfaces/objectModelInterfaces";

export default Vue.extend({
  mixins: [
    selectedMixin,
    ObjectModelPermissionMixin,
    permissionTablePermitteesMixin,
    remainingColumnMixin,
    dataTaggableFieldMixin,
  ],
  props: {
    property: {
      type: Object as () => ObjectModelProperty,
      required: true,
    },
  },
  computed: {
    permissionType(): ObjectModelPermissionType {
      return ObjectModelPermissionType.Property;
    },
    propertyTitleTooLong(): boolean {
      return this.property.defaultLabelTitle.length > 20;
    },
    propertyTitleShort(): string {
      return StringHelper.limitString(this.property.defaultLabelTitle, 20);
    },
    dataTaggableField(): IObjectModelProperty {
      return this.property;
    },
  },
});
</script>